import React from 'react';

const IntegrationStatuses: React.FC = () => {
  return (
    <div className="space-y-6">
      <h1 className="text-2xl font-bold text-gray-900">Integration Statuses</h1>
      <div className="card">
        <p className="text-gray-600">Integration statuses functionality will be implemented here.</p>
      </div>
    </div>
  );
};

export default IntegrationStatuses;
